/** Optimize only Cloudinary raster delivery, never documents or signed URLs. */
export function optimizedImageUrl(src: string, width = 1280): string {
  try {
    const url = new URL(src);
    if (url.protocol !== "https:" || url.hostname !== "res.cloudinary.com" || url.search) return src;
    const marker = "/image/upload/";
    const offset = url.pathname.indexOf(marker);
    if (offset < 0) return src;
    const rest = url.pathname.slice(offset + marker.length);
    if (rest.startsWith("s--")) return src;
    const extension = rest.match(/\.([a-z0-9]+)$/i)?.[1];
    if (extension && !/^(?:jpe?g|png|webp|avif|bmp|heic|tiff?)$/i.test(extension)) return src;
    const segments = rest.split("/");
    let index = 0;
    while (index < segments.length - 1 && /^(?:a|ar|b|bo|c|co|d|dl|dn|dpr|e|f|fl|fps|g|h|if|ki|l|o|p|pg|q|r|so|t|u|vc|vs|w|x|y|z)_/.test(segments[index])) {
      if (/^f_auto,q_auto,c_limit,w_\d+$/.test(segments[index])) {
        segments.splice(index, 1);
      } else index++;
    }
    const boundedWidth = Math.max(64, Math.min(2400, Math.round(width) || 1280));
    segments.splice(index, 0, `f_auto,q_auto,c_limit,w_${boundedWidth}`);
    url.pathname = url.pathname.slice(0, offset + marker.length) + segments.join("/");
    return url.href;
  } catch {
    return src;
  }
}

/** Committee content keeps its original, editor-authored image delivery. */
export function shouldResizeCmsImages(slug: string): boolean {
  return !/(?:^|-)committees?(?:-|$)/i.test(slug);
}

export function responsiveImageProps(src: string, maxWidth = 1280, resize = true) {
  if (!resize) return { src };
  const optimized = optimizedImageUrl(src, maxWidth);
  if (optimized === src) return { src };
  const widths = Array.from(new Set([320, 640, 960, 1280, 1600, maxWidth].filter(width => width <= maxWidth))).sort((a, b) => a - b);
  return {
    src: optimized,
    srcSet: widths.map(width => `${optimizedImageUrl(src, width)} ${width}w`).join(", "),
  };
}
